import { render } from "./uk8.vue?vue&type=template&id=7f546347"
import script from "./uk8.vue?vue&type=script&lang=js"
export * from "./uk8.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__